import React from 'react';
import request from '../../utils/agent';

export default class DocumentSignature extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            document_uuid: null,
            session_id: null,
            documentSigned: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        window.addEventListener("message", this.pandaDocListener, false);

        let user = {
            first_name: this.props.first_name,
            last_name: this.props.last_name,
            email: this.props.email,
            company_name: this.props.company_name,
            title: this.props.primary_jobtitle,
            reseller_title: "Reseller",
            business_name: this.props.business_name
        };

       // console.log('user', user);

        request.post('/api/reseller_agreement')
            .send(user)
            .then(resp => {
                let data = resp.body;
                this.setState({
                    session_id: data.session && data.session.id,
                    document_uuid: data.uuid
                });
            })
            .catch(err => {
                console.error(err);
            });
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.pandaDocListener);
    }

    pandaDocListener = (e) => {
        if (e && e.origin === 'https://app.pandadoc.com' && e.data) {
            try {
                let message = JSON.parse(e.data);
                if (message && message.event) {
                    // Document has been signed
                    if (message.event === 'session_view.document.completed') {
                        this.setState({documentSigned: true});
                    }
                }
            } catch (e) {
                console.error(e);
            }
        }
    };

    handleChange() {
        if(this.state.documentSigned === true) {
            //console.log('document_uuid', this.state.document_uuid);
            //console.log('signed', this.state.documentSigned );
            this.props.onChange('document_uuid', this.state.document_uuid);
        }
}



    render() {

        const {first_name, last_name, email, company_name, primary_jobtitle, business_name, onChange} = this.props;


        return (
            <div >
                <h3>Reseller Agreement</h3>
                <pre>{JSON.stringify(this.props.values, null, 2)}</pre>

                {this.state.session_id &&
                    <iframe src={`https://app.pandadoc.com/s/${this.state.session_id}`} width="800" height="800"></iframe>
                }

                {this.state.documentSigned === true ?
                    <div className='agreement--checkbox-holder'>
                        <input
                            type='checkbox'
                            className='agreement--checkbox'
                            id='doc_uuid'
                            value=''
                            onChange={this.handleChange}
                        />
                        <div className='checkbox-agreement-label'>I agree to the terms of the above document</div>
                    </div> :
                    <div className='agreement--checkbox-holder'>
                        <input
                            type='checkbox'
                            className='agreement--checkbox'
                            id='doc_uuid'
                            disabled={true}
                        />
                        <div className='checkbox-agreement-label'>Please read and sign agreement above</div>
                    </div>
                }


            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserSignupHome/DocumentSignature.js